import React from "react";
import LogoTramy from "../../../assets/logos/logo_blanco_tramy.png";
import PeruIcon from "../../../assets/img/peru.png";
import MexicoIcon from "../../../assets/img/mexico.png";
import ColombiaIcon from "../../../assets/img/colombia.png";
import SpainIcon from "../../../assets/img/spain.png";
import UnitedStatesIcon from "../../../assets/img/usa.jpg";
import AnchorImage from "../anchor-image";
import IabLogo from "../../../assets/logos/iab.png";
import { socialMediaArray } from "../../../constants/contents";
import "./styles.css";

function Footer() {
  return (
    <div className="footer">
      <img src={LogoTramy} alt="logo of tramy" />
      <div className="footer__info">
        <div className="footer__info-countries">
          <p>Plataforma de comercio conversacional para WhatsApp.</p>
          <ul>
            <li>
              <img src={PeruIcon} alt="flag of Peru" />
              Perú
            </li>
            <li>
              <img src={MexicoIcon} alt="flag of Mexico" />
              México
            </li>
            <li>
              <img src={SpainIcon} alt="flag of Spain" />
              España
            </li>
            <li>
              <img src={ColombiaIcon} alt="flag of Colombia" />
              Colombia
            </li>
            <li>
              <img src={UnitedStatesIcon} alt="flag of United States" />
              USA
            </li>
          </ul>
        </div>

        <div className="footer__info-media">
          <p>Síguenos en:</p>
          <span>
            {socialMediaArray.map((socialMedia) => (
              <AnchorImage link={socialMedia.link} image={socialMedia.image} />
            ))}
          </span>
        </div>
        <div className="footer__partners">
          <p>Respaldados por:</p>
          <img src={IabLogo} alt="Iab logo" />
        </div>
      </div>
      <div className="footer__copyright">
        <p>© Copyright 2021 Tramy.io</p>
        <p>Una empresa de DISOFT GROUP S.A.C</p>
      </div>
    </div>
  );
}

export default Footer;
